var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:_vm.cssClass},[_c('a',{class:_vm.cssClass,attrs:{"href":"javascript:void(0)"},on:{"click":function($event){$event.preventDefault();return _vm.$emit('click')}}},[_c('i',{class:_vm.icon,style:({ color: _vm.iconColor, fontSize: _vm.iconFontSize })}),(_vm.label)?_c('p',[_vm._v(_vm._s(_vm.label))]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }